/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
import React from 'react'

export default function (tip, children, getContent, multiline) {
  if (children) return children
  if (getContent !== undefined && getContent !== null) return getContent // getContent can be 0, '', etc.
  if (getContent === null) return null // Tip not exist and children is null or undefined

  const regexp = /<br\s*\/?>/
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip
  }

  // Multiline tooltip content
  return tip.split(regexp).map((d, i) => {
    return (
      <span key={i} className='multi-line'>{d}</span>
    )
  })
}
